import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage, injectIntl } from '../../../../../components/Intl/withIntl.js';
import { Container, Card, Row, Col } from 'react-bootstrap';

import { connect } from 'react-redux';
import { getFile } from '../../../../../util/file.js';

import { getContentBlockItemByName, getContentBlockItemValue } from '../../../CmsActions.js';

import HtmlComponent from '../../../../../components/Text/HtmlComponent.js';

function PanelPrefooter({ intl, panel }) {
	const image = getContentBlockItemByName(panel?.blocks, 'image');
    const title = getContentBlockItemValue(panel.blocks, 'title');
    const content = getContentBlockItemValue(panel.blocks, 'content');

	if(content) {
		return (
			<div className="py-md-4 bg-info">
				<Container>
					<Row>
						<Col xs="12" md="8" xl="6">
							<div className="p-2 p-md-0 text-center text-md-start">
								{title && <h2 className="text-primary">{title}</h2>}
								<HtmlComponent text={content} />
							</div>
						</Col>
						<Col md="4" xl="6">
							{image && <img src={getFile(image.path)} alt={image.text || title} className="w-100 rounded" loading="lazy" />}
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
	return null;
}

function mapStateToProps(store, props) {
	return {
	};
}

PanelPrefooter.propTypes = {
	intl: PropTypes.object.isRequired,
    panel: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(injectIntl(PanelPrefooter));
